const useDocumentScript = () => {
	const addScriptToDocument = (
		scriptPath: string,
		scriptPreLoadInitialize: (() => void) | null,
		scriptLoadedCallback: (() => void) | null,
		externalDomain: boolean,
		dataAttributes?: { [key: string]: string },
		scriptErrorCallback?: (() => void) | null
	) => {
		if (scriptPreLoadInitialize) {
			scriptPreLoadInitialize();
		}
		const script = document.createElement("script");
		script.type = "text/javascript";
		script.async = true;
		script.src = scriptPath;
		if (externalDomain) {
			const res = document.createElement("link");
			res.rel = "preload";
			res.as = "script";
			res.href = scriptPath;
			document.head.appendChild(res);
		}
		if (scriptLoadedCallback) {
			script.onload = scriptLoadedCallback;
		}
		if (scriptErrorCallback) {
			script.onerror = scriptErrorCallback;
		}
		dataAttributes &&
			Object.keys(dataAttributes).forEach(key => {
				script.setAttribute(key, dataAttributes[key]);
			});
		document.body.appendChild(script);
	};

	return addScriptToDocument;
};

export default useDocumentScript;
